import React, { useState, useEffect } from "react";
import Loader from "../../../Common/Loader/loader";
import { AllOwnerTypeDetails } from "../../../Apis/ownerTypeApi";
import {
  getAllCircleWiseReportCircle,
} from "../../../Apis/scvReports/reportedSCVApi";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import { AllTransferStationTransactions } from "../../../Apis/TransferStationReport/allTransferStationTransactionApi";
import { useNavigate, useLocation } from "react-router-dom";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import {
  getFourTimeTripsInnerReportTransaction,
  getMoreThanFourTimeTripsInnerReportTransaction,
  getOneTimeTripsInnerReportTransaction,
  getThreeTimeTripsInnerReportTransaction,
  getTwoTimeTripsInnerReportTransaction,
} from "../../../Apis/scvReports/overallScvTripsApi";
import { AllSecondaryDeploymentReport } from "../../../Apis/TransferStationReport/secondaryDeploymentTransactionReportApi";
import { formatDateTimeWithoutSec, getCurrentDateTime1 } from "../../../Common/helper/helpar";

const SCVInnerCircleReports = () => {

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [ownerTypeDetails, setOwnerTypeDetails] = useState([]);
  const [zonesData, setZonesData] = useState([]);
  const [fromDate, setFromDate] = useState(getStartOfCurrentDate());
  const [toDate, setToDate] = useState(getCurrentDateTime());
  const [selectedOwnerType, setSelectedOwnerType] = useState("");
  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  const location = useLocation();
  const { data, formatFromDate, formatToDate } = location.state;
  const DeployedFromDate = localStorage.getItem("DeployedFromDate");
  const DeployedToDate = localStorage.getItem("DeployedToDate1");
  const DeployedOwnerType = localStorage.getItem("DeployedOwnerType");
  const DeployedVehicleType = localStorage.getItem("vehicleType");
  useEffect(() => {
    const fetchOwnerTypeData = async () => {
      try {
        const ownerTypeData = await AllOwnerTypeDetails();
        setOwnerTypeDetails(ownerTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchOwnerTypeData();
  }, []);

  useEffect(() => {
    fetchData(); // Fetch data when component mounts with default selected dates
  }, []);
  const zone = localStorage.getItem('zone')
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await getAllCircleWiseReportCircle(
        fromDate,
        toDate,
        zone,
        selectedOwnerType

      );
      setZonesData(response.data);
      // Handle the response data as needed
    } catch (error) {
      console.error("Error fetching zone wise report:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const scvReportColumns = [
    {
      name: "S.No",
      width: '70px',
      selector: (row) => row["sno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
    },
    {
      name: "Corporation",
      selector: (row) => row["corporationName"],
      cell: (row) => <span>{row["corporationName"] || "N/A"}</span>,
      sortable: true,
    },
    {
      name: "Circle",
      selector: (row) => row["circleName"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["circleName"]}
        </span>
      ),
      sortable: true,
      width: '170px',
    },
    {
      name: "Deployment",
      selector: (row) => row["deployment"],
      cell: (row) => (
        <span style={{ color: "blue", cursor: "pointer" }} onClick={() => handleDeploymentClick(row)}>{row["deployment"]}</span>
      ),
      sortable: true,
      width: '200px',
    },
    {
      name: "Total Trips",
      selector: (row) => row["totalTrips"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => handleTotalTrip(row["circleId"])}
        >
          {" "}
          {row["totalTrips"]}
        </span>
      ),
      sortable: true,
      width: '140px',
    },
    {
      name: "Trip-1",
      selector: (row) => row["oneTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => handleOneTripClick(row, fromDate, toDate)}
        >
          {row["oneTrip"]}
        </span>
      ),
      sortable: true,
      width: '140px',
    },
    {
      name: "Trip-2",
      selector: (row) => row["twoTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => handleTwoTripClick(row, fromDate, toDate)}
        >
          {row["twoTrip"]}
        </span>
      ),
      sortable: true,
      width: '140px',
    },
    {
      name: "Trip-3",
      selector: (row) => row["threeTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => handleThreeTripClick(row, fromDate, toDate)}
        >
          {row["threeTrip"]}
        </span>
      ),
      sortable: true,
      width: '140px',
    },
    {
      name: "Trip-4",
      selector: (row) => row["fourTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => handleFourTripClick(row, fromDate, toDate)}
        >
          {row["fourTrip"]}
        </span>
      ),
      sortable: true,
      width: '140px',
    },
    {
      name: ">05 Trip",
      selector: (row) => row["moreThanFiveTrip"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => handleMoreThanFourTripClick(row, fromDate, toDate)}
        >
          {row["moreThanFiveTrip"]}
        </span>
      ),
      sortable: true,
      // width: '140px',
    },
  ];

  const handleTotalTrip = async (circleId) => {
    try {
      setIsLoading(true);
      const response = await AllTransferStationTransactions(
        DeployedFromDate,
        toDate,
        "",
        "",
        circleId,
        "2",
        DeployedOwnerType,
        DeployedVehicleType,
        ""

      );
      navigate("/deployed-trips-tssctp", { state: { data: response.data, fromDate: DeployedFromDate, toDate: toDate } });
    } catch (error) {
      console.error("Error fetching circle wise report:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOneTripClick = async (row, fromDate, toDate) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      let response1;
      if (row.zoneId !== "" && row.circleId === "") {
        response1 = await getOneTimeTripsInnerReportTransaction(
          DeployedFromDate,
          toDate,
          "",
          row.circleId,
          "2",
          "",
          DeployedOwnerType,
          DeployedVehicleType // Pass empty string for circleId
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response1 = await getOneTimeTripsInnerReportTransaction(
          DeployedFromDate,
          toDate,
          "",
          row.circleId, // Pass circleId,
          "2",
          "",
          DeployedOwnerType,
          DeployedVehicleType // Pass empty string for circleId
        );
      }
      navigate("/view-overall-trips", { state: { data: response1.data, fromDate: DeployedFromDate, toDate: toDate } });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleTwoTripClick = async (row, fromDate, toDate) => {
    console.log(row)
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      let response1;
      if (row.zoneId !== "" && row.circleId === "") {
        response1 = await getTwoTimeTripsInnerReportTransaction(
          DeployedFromDate,
          toDate,
          "",
          row.circleId, // Pass circleId,
          "2",
          "",
          DeployedOwnerType,
          DeployedVehicleType
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response1 = await getTwoTimeTripsInnerReportTransaction(
          DeployedFromDate,
          toDate,
          "",
          row.circleId,
          "2",
          "",
          DeployedOwnerType,
          DeployedVehicleType
        );
      }
      navigate("/view-overall-trips", { state: { data: response1.data, fromDate: DeployedFromDate, toDate: toDate } });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleThreeTripClick = async (row, fromDate, toDate) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      let response1;
      if (row.zoneId !== "" && row.circleId === "") {
        response1 = await getThreeTimeTripsInnerReportTransaction(
          DeployedFromDate,
          toDate,
          "",
          row.circleId, // Pass circleId,
          "2",
          "",
          DeployedOwnerType,
          DeployedVehicleType
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response1 = await getThreeTimeTripsInnerReportTransaction(
          DeployedFromDate,
          toDate,
          "",
          row.circleId, // Pass circleId,
          "2",
          row.transferStationId,
          DeployedOwnerType,
          DeployedVehicleType
        );
      }
      navigate("/view-overall-trips", { state: { data: response1.data, fromDate: DeployedFromDate, toDate: toDate } });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleFourTripClick = async (row, fromDate, toDate) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      let response1;
      if (row.zoneId !== "" && row.circleId === "") {
        response1 = await getFourTimeTripsInnerReportTransaction(
          DeployedFromDate,
          toDate,
          "",
          row.circleId, // Pass circleId,
          "2",
          "",
          DeployedOwnerType,
          DeployedVehicleType
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response1 = await getFourTimeTripsInnerReportTransaction(
          DeployedFromDate,
          toDate,
          "",
          row.circleId, // Pass circleId,
          "2",
          row.transferStationId,
          DeployedOwnerType,
          DeployedVehicleType
        );
      }
      navigate("/view-overall-trips", { state: { data: response1.data, fromDate: DeployedFromDate, toDate: toDate } });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleMoreThanFourTripClick = async (row, fromDate, toDate) => {
    setIsOptionsLoading(true);
    try {
      setIsLoading(true);
      let response1;
      if (row.zoneId !== "" && row.circleId === "") {
        response1 = await getMoreThanFourTimeTripsInnerReportTransaction(
          DeployedFromDate,
          toDate,
          "",
          row.circleId, // Pass circleId,
          "2",
          "",
          DeployedOwnerType,
          DeployedVehicleType
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response1 = await getMoreThanFourTimeTripsInnerReportTransaction(
          DeployedFromDate,
          toDate,
          "",
          row.circleId, // Pass circleId,
          "2",
          row.transferStationId,
          DeployedOwnerType,
          DeployedVehicleType
        );
      }
      navigate("/view-overall-trips", { state: { data: response1.data, fromDate: DeployedFromDate, toDate: toDate } });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeploymentClick = async (row) => {
    try {
      setIsLoading(true);
      let response;
      if (row.zoneId !== "" && row.circleId === "") {
        response = await AllSecondaryDeploymentReport(
          DeployedFromDate,
          toDate,
          row.zoneId,
          "", // Pass empty string for circleId
          DeployedOwnerType,
          "",
          DeployedVehicleType,
          ""

        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response = await AllSecondaryDeploymentReport(
          DeployedFromDate,
          toDate,
          "",
          row.circleId, // Pass circleId,
          DeployedOwnerType,
          "",
          DeployedVehicleType,
          ""
        );
      }
      navigate("/view-deployed-trips", { state: { data: response.data, fromDate:formatFromDate, toDate:formatToDate } });
    } catch (error) {
      console.error("Error fetching SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackClick = () => {
    navigate(-1); // Navigate back one step in the history stack
  };

  const date1 = localStorage.getItem("fromDate")
  const date2 = localStorage.getItem("toDate")

  const handleFromDateChange = (e) => {
    const newFromDate = e.target.value;
    localStorage.setItem("fromDate", newFromDate);
    setFromDate(newFromDate);
  };

  const handleToDateChange = (e) => {
    const newToDate = e.target.value;
    localStorage.setItem("toDate", newToDate);
    setToDate(newToDate);
  };


  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1
      }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Circle Wise SCVs Deployed trips to TS/SCTP Performance as on (${formatFromDate ? formatDateTimeWithoutSec(formatFromDate) : getCurrentDateTime()} To ${formatToDate ? formatDateTimeWithoutSec(formatToDate) : getCurrentDateTime()}) (at ${getCurrentDateTime1()})`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add row for download date and time
    const downloadDateTime = `Reported on: ${formattedDate} ${formattedTime}`;
    const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 5);
    dateTimeRow.getCell(3).font = boldFont; // Set style for the cell
    dateTimeRow.getCell(3).alignment = { horizontal: "center" }; // Center align the cell content
    dateTimeRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 5) {
        // Apply styles to download date and time cells
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    // Add row for cumulative heading report
    const cumulativeHeadingRow = worksheet.addRow(["", "", cumulativeHeadingReport, "", ""]);
    worksheet.mergeCells(2, 3, 2, 7);
    cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 7) {
        // Apply styles to cumulative heading report cells
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Corporation",
      "Circle",
      "Deployment",
      "Total Trips",
      "One Trip",
      "Two Trip",
      "Three Trip",
      "Four Trip",
      "Morethan Five Trip"
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 12) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" } // Red background color
        };
      }
    });

    // Add data rows
    (zonesData || []).forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.corporationName ?? "N/A",
        item.circleName ?? "N/A",
        item.deployment ?? "N/A",
        item.totalTrips ?? "N/A",
        item.oneTrip ?? "N/A",
        item.twoTrip ?? "N/A",
        item.threeTrip ?? "N/A",
        item.fourTrip ?? "N/A",
        item.moreThanFiveTrip ?? "N/A"
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 12) {
          // Align the columns from 1 to 4 to the left
          cell.alignment = { horizontal: "left" };
        } else {
          // Align the rest of the columns to the center
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "SCVsInnerCircleReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="card">
                <div className="card-body">

                  <div class="row align-items-end" style={{ textAlign: "justify" }}>
                    {/* <div class="col-md-3 ">
                <label htmlFor="fromDate">From Date:</label>
                <input
                  type="datetime-local"
                  id="fromDate"
                  style={{ backgroundColor: "#fff",borderRadius:'0px' }}
                  className="form-control"
                  value={fromDate}
                  onChange={handleFromDateChange}
                />
              </div>

              <div class="col-md-3 ">
                <label htmlFor="toDate">To Date:</label>
                <input
                  type="datetime-local"
                  id="toDate"
                  className="form-control"
                  style={{ backgroundColor: "#fff",borderRadius:'0px'  }}
                  value={toDate}
                  onChange={handleToDateChange}
                />
              </div>

              <div class="col-md-3">
                <label htmlFor="Owner type">Owner Type</label>
                <select
                  className="form-select"
                  style={{ backgroundColor: "#fff",borderRadius:'0px'  }}
                  name="ownerTypeId"
                  id="ownerType"
                  value={selectedOwnerType}
                  onChange={(e) => setSelectedOwnerType(e.target.value)}
                >
                  <option value="">Select</option>
                  {ownerTypeDetails.map((ownerType) => (
                    <option
                      key={ownerType.ownerTypeId}
                      value={ownerType.ownerTypeId}
                    >
                      {ownerType.ownerTypeName}
                    </option>
                  ))}
                </select>
              
            </div> */}
                    <div className="col-md-12">
                      <div className="d-flex justify-content-end" >
                        <button
                          className="btn btn-secondary me-3"
                          onClick={handleBackClick}
                        >
                          Back
                        </button>
                        <button
                          className="btn btn-excel"
                          onClick={downloadAsExcel}>
                          <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="top-header mt-3">
                    <span>
                      {" "}
                      Circle Wise SCVs Deployed trips to TS/SCTP Performance
                      ({formatFromDate ? formatDateTimeWithoutSec(formatFromDate) : getCurrentDateTime()} To {formatToDate ? formatDateTimeWithoutSec(formatToDate) : getCurrentDateTime()}) (at {getCurrentDateTime1()})

                    </span>
                  </div>

                  <CustomDataTable
                    data={zonesData}
                    columns={scvReportColumns}
                  // headers={headers}
                  // link={true}
                  // search={true}
                  // fromDate={fromDate}
                  // toDate={toDate}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
    </>
  );
};

// Function to get default date in "YYYY-MM-DDTHH:MM" format
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

export default SCVInnerCircleReports;

